import React, { useState, useEffect } from 'react'
import {
    Typography,
} from '@material-ui/core'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

import {Redirect} from'react-router-dom'

// styles
const useStyles = makeStyles(theme => ({
	root: {
		marginTop: 100,
		textAlign: 'center',
	},
  }));

function SignupSuccess(props) {
	const classes = useStyles()

	var [redirect, setRedirect] = useState(false)

	useEffect(() =>{
		setTimeout(()=>{
			setRedirect({redirect:true})
		}, 5000)
	})

    return (
		redirect? <Redirect to = "/login"/> :
		<div className={classes.root}>
			<Typography variant='h4'>Signup Successfull</Typography>
			<Typography variant='h6'>We just sent you an email. Please verify your email address.</Typography>
		</div>
	)
}

export default withRouter(SignupSuccess)
